export class AnimatorState2DScript {
    setPlayScriptInfo(animator, layerindex, playstate) {
        this.playStateInfo.animator = animator;
        this.playStateInfo.layerindex = layerindex;
        this.playStateInfo.playState = playstate;
    }
    constructor() {
        this.playStateInfo = { animator: null, layerindex: -1, playState: null };
    }
    onStateEnter() {
    }
    onStateUpdate(normalizeTime) {
    }
    onStateExit() {
    }
    onStateSwitch(currentState) {
    }
    onStateLoop() {
    }
}
